<template>
    <div id="sidenav-collapse-main" class="collapse navbar-collapse w-auto h-auto h-100">
        <ul class="navbar-nav">
            <li class="nav-item">
                <sidenav-collapse nav-text="Inicio" :collapse="false" url="#" :aria-controls="''"
                    @click="toggleComponent('PrincipalCard')">
                    <template #icon>
                        <i class="fa fa-arrow-right text-dark" style="font-size: 16px;"></i>
                    </template>
                </sidenav-collapse>
            </li>
            <li class="nav-item">
                <sidenav-collapse nav-text="Informações da Obra" :collapse="false" url="#" :aria-controls="''"
                    @click="toggleComponent('InfoBuilding')">
                    <template #icon>
                        <i class="fa fa-building-o text-dark" style="font-size: 16px;"></i>
                    </template>
                </sidenav-collapse>
            </li>

            <li class="nav-item">
                <sidenav-collapse nav-text="Central Financeira" :collapse="false" url="#" :aria-controls="''"
                    @click="toggleComponent('FinancialCenter')">
                    <template #icon>
                        <i class="fa fa-line-chart text-dark" style="font-size: 16px;"></i>
                    </template>
                </sidenav-collapse>
            </li>

            <li class="nav-item">
                <sidenav-collapse nav-text="Dados Cadastrais" :collapse="false" url="#" :aria-controls="''"
                    @click="toggleComponent('UpdateUser')">
                    <template #icon>
                        <i class="fa fa-paperclip text-dark" style="font-size: 16px;"></i>
                    </template>
                </sidenav-collapse>
            </li>

            <li class="nav-item">
                <sidenav-collapse nav-text="Agendamento" :collapse="false" url="#" :aria-controls="''"
                    @click="toggleComponent('Schedule')">
                    <template #icon>
                        <i class="fa fa-calendar-check-o text-dark" style="font-size: 16px;"></i>
                    </template>
                </sidenav-collapse>
            </li>

            <li class="nav-item" style="font-size: 10px;">
                <sidenav-collapse nav-text="Doc. e Comunicados" :collapse="false" url="#" :aria-controls="''"
                    @click="toggleComponent('DocsAndCommunication')">
                    <template #icon>
                        <i class="fa fa-file-text-o text-dark" style="font-size: 16px;"></i>
                    </template>
                </sidenav-collapse>
            </li>

            <li class="nav-item">
                <sidenav-collapse nav-text="Assistência Técnica" :collapse="false" url="#" :aria-controls="''"
                    @click="toggleComponent('TechnicalAssistance')">
                    <template #icon>
                        <i class="fa fa-wrench text-dark" style="font-size: 16px;"></i>
                    </template>
                </sidenav-collapse>
            </li>

            <li class="nav-item">
                <sidenav-collapse nav-text="Personalização" :collapse="false" url="#" :aria-controls="''"
                    @click="toggleComponent('Customization')">
                    <template #icon>
                        <i class="fa fa-paint-brush text-dark" style="font-size: 16px;"></i>
                    </template>
                </sidenav-collapse>
            </li>

            <li class="nav-item">
                <sidenav-collapse nav-text="Fale Conosco" :collapse="false" url="#" :aria-controls="''"
                    @click="toggleComponent('ContactUs')">
                    <template #icon>
                        <i class="fa fa-headset text-sm text-dark" style="font-size: 16px;"></i>
                    </template>
                </sidenav-collapse>
            </li>

            <li class="nav-item">
                <sidenav-collapse nav-text="Perguntas Frequentes" :collapse="false" url="#" :aria-controls="''"
                    @click="toggleComponent('CustomerService')">
                    <template #icon>
                        <i class="fa fa-question-circle text-dark" style="font-size: 16px;"></i>
                    </template>
                </sidenav-collapse>
            </li>
        </ul>
    </div>
</template>

<script setup>

import SidenavCollapse from "./SidenavCollapse.vue";
import { useStore } from "vuex";

const store = useStore();

const toggleComponent = (component) => {
    if (window.innerWidth < 1200) {
        navbarMinimize();
        scrollToBottom()
    }
    store.commit("updateComponent", component)
}
const scrollToBottom = () => {
    document.getElementById('btn_scroll').click()
};

const navbarMinimize = () => store.commit("navbarMinimize");
</script>
<style scoped>
.nav-item {
    cursor: pointer;
}

.navbar-vertical.navbar-expand-xs .navbar-nav>.nav-item {
    margin-top: -0.7rem;
}
</style>
